/**
 * Timber groups a log file may be archived in besides the shared `A9Search/<stack>/<AMI>/ES2/Alpha/<file>`.
 * To see a domain's actual groups, run `mechanic execute aws timber list-log-groups` with
 * `--group "OpenSearch/%/<client-id>/<domain-name>/"` or `--group "<stack>/%/<client-id>/<domain-name>/"`.
 */

/** Containerized group of an AMI log file; `{stack}` is `swift-<region>-<suffix>`. */
export const CONTAINERIZED_GROUPS: Record<string, string> = {
  'elasticsearch.log': '{stack}/OpenSearch/elasticsearch.log',
  'elasticsearch_index_indexing_slowlog.log': '{stack}/OpenSearch/elasticsearch_index_indexing_slowlog.log',
  'elasticsearch_index_search_slowlog.log': '{stack}/OpenSearch/elasticsearch_index_search_slowlog.log',
  'elasticsearch_index_warm_slowlog.log': '{stack}/OpenSearch/elasticsearch_index_warm_slowlog.log',
  'es.metrics.log': '{stack}/OpenSearch/es.metrics.log',
  'auth.metrics.log': '{stack}/OpenSearch/auth.metrics.log',
  'auth.general.log': '{stack}/OpenSearch/auth.general.log',
  'pa.plugin.stats.log': '{stack}/OpenSearch/pa.plugin.stats.log',
  'opendistro_security_audit.log': '{stack}/OpenSearch/opendistro_security_audit.log',
  'opendistro_security_audit_service.log': '{stack}/OpenSearch/opendistro_security_audit_service.log',
  'ReactionWheel.log': 'OpenSearch/{stack}/ReactionWheel/ReactionWheel.log',
  'reactionwheel_application_metrics.log': 'OpenSearch/{stack}/ReactionWheel/reactionwheel_application_metrics.log',
  'haproxy.log': 'OpenSearch/{stack}/ServiceProxy/haproxy.log',
};

/** Files also archived in the shared group scoped to the domain, by component (OS and OSD: any version). */
export const DOMAIN_SCOPED_SHARED_FILES: Record<string, readonly string[]> = {
  OS: [
    'auth.general.log',
    'auth.metrics.log',
    'aws-requests.general',
    'check-for-hung-es.general.log',
    'check-vpc-eni-eth1-routes.general.log',
    'elasticsearch.log',
    'elasticsearch_index_indexing_slowlog.log',
    'elasticsearch_index_search_slowlog.log',
    'es.metrics.log',
    'log_truncate.log',
    'metrics-db-files-concater.log',
    'opendistro_security_audit_service.log',
    'pa.plugin.stats.log',
    'read-node-discovery-file.general.log',
    'service_log',
    'supervisord.es.log',
    'supervisord.log',
    'write-node-discovery-file.general.log',
  ],
  OSD: [
    'aws-requests.general',
    'check-for-hung-kibana.general.log',
    'kibana.log',
    'log_truncate.log',
    'service_log',
    'supervisord.kibana.log',
    'supervisord.log',
  ],
  LogPusherAMI: ['a9-ec2-boot-start.log', 'cw-log-pusher.general.log', 'cw.agent.log', 'cwagent.metrics.log', 'service_log'],
  SDPDAgentAMI: ['sdpd_agent.log', 'sdpd_metrics.log', 'service_log'],
  InstanceControllerAMI: ['access', 'aws-requests.general', 'errors', 'healthcheck.general', 'processmanager', 'service_log'],
};
